import { Routes } from "@angular/router";

export const routes: Routes = [
    {
        path: "triage/:id",
        loadComponent: () => import("./triage.component").then((c) => c.TriageComponent)
    }
];
